import { render, staticRenderFns } from "./AlarmPlacePage.vue?vue&type=template&id=395d451e&scoped=true"
import script from "./AlarmPlacePage.vue?vue&type=script&lang=js"
export * from "./AlarmPlacePage.vue?vue&type=script&lang=js"
import style0 from "./AlarmPlacePage.vue?vue&type=style&index=0&id=395d451e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d451e",
  null
  
)

export default component.exports